import React, {useState, useEffect} from 'react';

import PropTypes from 'prop-types';

/**
 * This Component serves simply as a stateful headless data controller to allow for
 * persistence of DataTable State.
 * @param children
 * @param defaultTableState (to be provided from config translation)
 * @returns {*}
 * @constructor
 */
const TableStateManager = ({
   children,
   defaultTableState
}) => {

    let [tableState, setTableState] = useState(defaultTableState);

    useEffect(() => {
    }, [tableState]);

    return (
        children({
            tableState,
            setTableState
        })
    )
};


TableStateManager.propTypes = {
    children: PropTypes.func.isRequired,
    defaultTableState: PropTypes.object
};

TableStateManager.defaultProps = {
    defaultTableState: {}
};

export default TableStateManager;

